import { css } from "lit";

export const styles = css`
    :host {
      display: block;
    }

    .modal-content {
      padding: 0;
    }

    .form-group {
      margin-bottom: 1.5rem;
    }

    .form-group:last-child {
      margin-bottom: 0;
    }

    label {
      display: block;
      margin-bottom: 0.5rem;
      font-weight: 600;
      color: var(--sl-color-neutral-700);
      font-size: 0.875rem;
    }

    sl-input,
    sl-select {
      width: 100%;
      margin-bottom: 0.5rem;
    }

    .error-message {
      display: flex;
      align-items: center;
      padding: 0.75rem;
      margin-bottom: 1rem;
      background: var(--sl-color-danger-50);
      border: 1px solid var(--sl-color-danger-200);
      border-radius: 6px;
      color: var(--sl-color-danger-700);
      font-size: 0.875rem;
    }

    .error-message sl-icon {
      margin-right: 0.5rem;
    }

    .form-footer {
      margin-top: 2rem;
      padding-top: 1rem;
      border-top: 1px solid var(--sl-color-neutral-200);
    }
  `;